import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Card from './card';
import ApiService from '../../../services/apiService';
import functionsService from '../../../services/functionsService';
export default {
  name: 'IsFMDoorCard',
  inheritAttrs: false,
  props: _objectSpread(_objectSpread({}, Card.props), {}, {
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: ''
    },
    subIconColor: {
      type: String,
      default: ''
    },
    subTextColor: {
      type: String,
      default: ''
    },
    subText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    smallValue: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    buttoncolor: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    favUserId: {
      type: String,
      default: ''
    },
    favObjectId: {
      type: Number,
      default: undefined
    },
    favType: {
      type: String,
      default: ''
    },
    accessKeyDates: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }),
  data: function data() {
    return {
      loader: null,
      loading: false,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
  },
  computed: {},
  watch: {
    loader: function loader() {
      var _this = this;

      var l = this.loader;
      this[l] = !this[l];
      setTimeout(function () {
        return _this[l] = false;
      }, 11500);
      this.loader = null;
    }
  },
  methods: {
    processDoor: function processDoor() {
      var _this2 = this;

      this.loader = 'loading';
      ApiService.isFmAccessActivateLock({
        id: this.$attrs['isfmaccessid']
      }).then(function () {
        _this2.$snack(_this2.$i18n_t('IS.FM.AccessMgmt.doorActivated'), 'success');
      }).catch(function (error) {
        var userRights = functionsService.userAccessRightHandling(error.response.data.data, _this2);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack("".concat(userRights, " - ").concat(_this2.$i18n_t('IS.FM.AccessMgmt.doorFailed')), 'error');
        }
      }).finally(function () {
        _this2.$store.state.app.loading = false;
      });
    }
  }
};